export const SITE_URL = 'https://accounteditor.com';
export const SITE_NAME = 'Account Editor';
export const TITLE_SUFFIX = ' — Account Editor';
export const DEFAULT_DESCRIPTION =
  'Account Editor: the post-purchase Shopify app. Self-serve order edits, smart cancel deflection, and one-click upsells. Trusted by 1,200+ brands. Live in 5 minutes.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-image.jpg`;
export const TWITTER_HANDLE = '@orderfix';

export const formatTitle = (title) => {
  if (!title) return `${SITE_NAME} — Self-Serve Order Editing for Shopify`;
  if (title.includes(SITE_NAME)) return title;
  return `${title}${TITLE_SUFFIX}`;
};

export const canonicalFor = (path) => {
  const p = path || (typeof window !== 'undefined' ? window.location.pathname : '/');
  const trimmed = p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p;
  return `${SITE_URL}${trimmed}`;
};
